import AutosizeInput from 'react-input-autosize'
import styled, { ITheme } from '../../../theme'
import { IWithSize } from '../../../containers/BookingCalendar/Calendar/Calendar'

const StyledInput = styled(AutosizeInput)<IWithSize>`
  & > input {
    border: none;
    outline: none;
    caret-color: ${(props: ITheme) => props.theme.colors.palette.emerald};
    margin-right: ${({ size }) => (size ? 8 * size : 8)}px;
    font-weight: bold;
    font-size: ${({ size }) => (size ? 14 * size : 14)}px;
    max-width: 100%;
  }
  line-height: ${({ size }) => (size ? 14 * size : 14)}px;
  padding-bottom: ${({ size }) => (size ? 10 * size : 10)}px;
  max-width: 100%;
`

export default StyledInput
